import React, { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
//import Transition from 'react-transition-group/Transition';
//import TransitionGroup from 'react-transition-group/TransitionGroup';

import Stage from '../Stage/Stage';
//import StageTracker from '../StageTracker/StageTracker';

import * as actions from '../../actions/index';
//import icons from '../../data/icons';

import './Group.css';

let timeout = false;

class Group extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollAnimating: false,
    };
    this.handleWheel = this.handleWheel.bind(this);
    this.handleProgression = this.handleProgression.bind(this);
    this.scrollDownClick = this.scrollDownClick.bind(this);
    this.groupLength = this.props.data.stages.length;
    this.scrollWaiting = false;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentStage !== this.props.currentStage) {
      this.setState({
        scrollAnimating: true,
      });
      timeout = setTimeout(() => {
        this.setState({
          scrollAnimating: false,
        });
        clearTimeout(timeout);
      }, 500);
    }
  }

  setScrollWait() {
    this.scrollWaiting = true;
    timeout = setTimeout(() => {
      this.scrollWaiting = false;
      clearTimeout(timeout);
    }, 1000);
  }

  handleWheel(event) {
    const groupLength = (this.props.data.stages && this.props.data.stages.length) || 0;

    if (!this.props.data.stages[this.props.currentStage] || (this.props.data.stages[this.props.currentStage].overlay && !this.props.overlay)) {
      return;
    }
    //console.log('Scrolling', this.props.currentStage, event.deltaX, event.deltaY, this.scrollWaiting, (this.props.currentStage + 1), groupLength, this.props.currentSection);

    if (event.deltaY > 0 && (this.props.currentStage + 1) < groupLength && !this.scrollWaiting) {
      this.setScrollWait();
      //console.log('going to stage', this.props.currentStage + 1)
      this.props.goToStage(this.props.currentStage + 1);
    }
    if (event.deltaY > 0 && (this.props.currentStage + 1) === groupLength && !this.scrollWaiting) {
      this.handleProgression();
      return;
    }
    if (event.deltaY < 0 && this.props.currentStage > 0 && !this.scrollWaiting) {
      this.setScrollWait();
      this.props.goToStage(this.props.currentStage - 1);
    }
  }

  handleProgression() {
    //console.log('Want to handle progression', this.props.currentSection , this.props.sectionCount, (this.props.sectionCount - 1), this.props.currentSection < (this.props.sectionCount - 1))
    // const endsNav = (this.props && this.props.data && this.props.data.endsNav) || false;
    if(this.props.currentSection < (this.props.sectionCount - 1)) {
      //console.log('going to section', this.props.currentSection + 1);
      this.props.goToSection(this.props.currentSection + 1);
    }

    return;
  }
  
  scrollDownClick() {
    this.handleWheel({ deltaY: 1 });
  }

  render() {
    this.groupLength = this.props.data.stages.length;
    return (
      <section
        className="group"
        id={this.props.data.id}
        tabIndex={'0'}
        onWheel={this.handleWheel}
      >
        {
          this.props.data && this.props.data.stages.map((item, i) => {
            return (this.props.currentStage === i) &&
              <Stage key={`stage-${item.id}`} data={item} group={this.props.data} currentSection={this.props.currentSection} currentGroup={this.props.currentGroup} currentStage={this.props.currentStage} backTo={item.hasOwnProperty('backTo') ? item.backTo : this.props.data.backTo} />;
          })
        }
      </section >
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    goToStage: (stageID) => {
      dispatch(actions.goToStage(stageID));
    },
    goToGroup: (groupID) => {
      dispatch(actions.goToGroup(groupID));
    },
    goToSection: (sectionID) => {
      dispatch(actions.goToSection(sectionID));
    },
  };
}


Group.propTypes = {
  data: propTypes.shape({
    title: propTypes.string,
    subtitle: propTypes.string,
    type: propTypes.string,
    video: propTypes.string,
    endsNav: propTypes.boolean,
    hideNav: propTypes.boolean,
    imageSequence: propTypes.object,
    images: propTypes.array,
    stages: propTypes.array,
    groupCount: propTypes.number,
    sectionCount: propTypes.number,
    backTo: propTypes.object,
  }),
  goToStage: propTypes.func.isRequired,
  goToGroup: propTypes.func.isRequired,
  goToSection: propTypes.func.isRequired,
  currentSection: propTypes.number.isRequired,
  currentGroup: propTypes.number.isRequired,
  currentStage: propTypes.number.isRequired,
  overlay: propTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    overlay: state.navigation.overlay,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Group);




// WEBPACK FOOTER //
// ./src/components/Group/Group.js